import {BehaviorSubject} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {wsOpened$} from './ws';
import {wwData$} from './worker-data';

export const trades$ = new BehaviorSubject([]);

wsOpened$.subscribe(() => trades$.next([]));

wwData$
  .pipe(
    filter((o) => o.type === 'trades'),
    map((o) => o.data.trades)
  )
  .subscribe((trades) => trades$.next(trades));
